/* this file requires productlistvalues.js, var prodListValues = new productListValues();*/
//console.log("pagination2018 start");
    $("#txtInnerSearch").on("keydown", function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            $("#submitInnerSearch").click();
        }
    });

    var pagination = angular.module('pagination', ['bnLazySrc', 'angularUtils.directives.dirPagination']);

    pagination.config(['$httpProvider', function ($httpProvider) {
        //paginationTemplateProvider.setPath('/Views/ProductList/pagingControls.html');
        $httpProvider.defaults.cache = false;
    }]);

    pagination.factory('dataFactory', ['$http', function ($http) {
        var items = {};
        var favBoards = {};
        return {
            getFavBoards: function (url) {
                favBoards = $http.get("favboards");
            },
            getData: function (url) {
                items = $http.get(url);
                return items;
            }
        };
    }]);

    pagination.controller('pagedItems', ['$scope', '$log', 'dataFactory',
        function ($scope, $log, dataFactory) {
            $scope.angSearch = [];
            $scope.angSearchTerm = "";
            // v: value; dn: display name
            $scope.sorts = [{ v: "-RelevenceScore", dn: "Relevance" },
                ///, { v: "LowestSellPriceAmount", dn: "Price low-high" },
                ///{ v: "[SellPrice1, LowestSellPriceAmount]", dn: "Price low-high" },
                { v: "SellPrice1", dn: "Price low-high" },
                { v: "-SellPrice1", dn: "Price high-low" },
                { v: "MinOrderQty", dn: "Minimum Quantity" },
                { v: "ProductName", dn: "Product Name" },
                { v: "ProductionTime", dn: "Production Time" },
                { v: "-AverageRating", dn: "Customer Rating" }];
            $scope.sortOrder = $scope.sorts[0].v;
            $scope.pageSizes = [20, 50, 100, 200];
            $scope.pageSize = prodListValues.GetItemsPerPage(); 
            $scope.layoutTypes = prodListValues.GetLayoutList(); 
            $scope.layoutType = $scope.layoutTypes[prodListValues.GetLayout()];
            $scope.freeSetupLink = localizedJS.FreeSetupLink;
            $scope.tagList = [];
		$scope.updateStructuredData = function(){
		
			var structitems = document.getElementsByClassName("itemstructureddata");
		      var itemsdisplayed = structitems.length;
		      	var itemlist = '';
		      	for(var x = 0; x < itemsdisplayed; x++){
		      		itemlist = itemlist + structitems[x].innerHTML.replace("##JSONINDEX##", x+1) + ',';
		      	}
		      	itemlist = itemlist.substring(0,itemlist.length-1);
		      	
		      	var alldata = "{ \"@context\":\"http://schema.org\", \"@type\":\"ItemList\", \"name\": \"##LISTNAME##\", \"url\": \"##LISTURL##\", \"image\": \"##LISTIMAGEURL##\", \"description\": \"##LISTDESC##\", \"numberOfItems\": \"##LISTCOUNT##\", \"itemListElement\":[ ##ITEMLIST## ]}";
		      	alldata = alldata.replace("##LISTNAME##", htmlEscape(document.title));
		      	alldata = alldata.replace("##LISTURL##", window.location.href);
		      	alldata = alldata.replace("##LISTIMAGEURL##", 'https:' + $('.thumbs > .productLink > a >  img').attr('bn-lazy-src'));
		      	alldata = alldata.replace("##LISTDESC##", htmlEscape($('meta[name=description]').attr("content")));
		      	alldata = alldata.replace("##LISTCOUNT##", itemsdisplayed);
		      	alldata = alldata.replace("##ITEMLIST##", itemlist.toString());
		      	//alldata = alldata.replace(/,\s*$/, "");
		      document.getElementById('structureddata').innerHTML = alldata.toString();
		
		};

		
		//On button click, match up input to the filtering term
		$scope.updateSearch = function () {
			var changeFromUrl = $('#searchFromUrl').val() == "true";
			if (changeFromUrl) {
				$('#searchFromUrl').val('false');
			} else {
				$('#currentPage').val(1);
			}
			var term = $('#txtInnerSearch').val();

			//$('#searchValue').val(term);
			$scope.angSearchTerm = term;
                    term = decodeURIComponent(term);
                    
                    
			var x = $.map($scope.tagList, function (obj, index) {
				if (obj.v.replace('&quot;','"').replace('&amp;', '&').replace("&#39;","'") == term.toLowerCase()) {
					return index;
				}
			});
                
                //console.log("pagination precheck");
			//If the searchterm matches a filter, click the filter, otherwise do a normal search in productnames
			if (x.length == 1){
			//console.log("pagination if true");
				var $filter = $('#'+ $scope.tagList[x].id);
				//if the filter is already checked, use the term for a regular search. Else, click the filter and skip the search
				if ($filter.hasClass('tagFilterChecked') || $filter.hasClass('colorChecked')){               
					$scope.angSearch.ProductName = $scope.angSearchTerm;
					$('#searchValue').val(term);
					$("#selectedSubSearch").remove();
					if(term.trim().length > 0){
						addSelectedSubSearch(term);
						$('#txtInnerSearch').attr('placeholder', localizedJS.NewSubSearchPlaceHolder);
						$('#txtInnerSearchLbl').html(localizedJS.NewSubSearchPlaceHolder);
					} else {
						$('#txtInnerSearch').attr('placeholder', localizedJS.SubSearchPlaceHolder);
						$('#txtInnerSearchLbl').html(localizedJS.SubSearchPlaceHolder);
					}
					if (!changeFromUrl) {
						UpdatedSearchUrl(!changeFromUrl); 
					}
				} else {  
					$filter.click();			
				}
			} else {                 
				$scope.angSearch.ProductName = $scope.angSearchTerm;
				$('#searchValue').val(term);
				$("#selectedSubSearch").remove();
				if(term.trim().length > 0){
			 		addSelectedSubSearch(term);
			 		$('#txtInnerSearch').attr('placeholder', localizedJS.NewSubSearchPlaceHolder);
			 		$('#txtInnerSearchLbl').html(localizedJS.NewSubSearchPlaceHolder);
				} else {
					$('#txtInnerSearch').attr('placeholder', localizedJS.SubSearchPlaceHolder);
					$('#txtInnerSearchLbl').html(localizedJS.SubSearchPlaceHolder);
				}
		
				if (!changeFromUrl) {
					UpdatedSearchUrl(!changeFromUrl); 
					//Log searchterm in Omniture
					if (typeof s != "undefined") {
						s.prop22 = term;
						var s_code = s.t(); if (s_code) document.write(s_code);
					}
				}
			}
					                
			$('#txtInnerSearch').val('');
			angular.element(document.getElementById('searchValue')).triggerHandler('change');
		};

            $scope.setSortOrder = function (sortOrder) {
                var changeFromUrl = $('#sortFromUrl').val() == "true";
                if (changeFromUrl) {
                    $('#sortFromUrl').val('false');
                } else {
                    $('#currentPage').val(1);
                }
                for (var i = 0; i < prodListValues.SortMap.length; i++){
                    if (prodListValues.SortMap[i].v.split(':')[1].toLowerCase() == sortOrder.toLowerCase()) {
                        productListMeta.SetOrder(prodListValues.SortMap[i].meta);
                        break;
                    }
                }
                $('#sortValue').val(sortOrder);
                $scope.sortOrder = sortOrder;

                if (!changeFromUrl) {
                    UpdateSortByUrl(!changeFromUrl);
                }
            };

            $scope.setPageSize = function (pageSize) {
                var changeFromUrl = $('#pageSizeFromUrl').val() == "true";
                if (changeFromUrl) {
                    $('#pageSizeFromUrl').val('false');
                } else {
                    $('#currentPage').val(1);
                }
                productListMeta.SetPageSize(pageSize);
                $scope.pageSize = pageSize;
                if (!changeFromUrl) {    
                    UpdateItemsPerPageUrl(!changeFromUrl);
                    //if(prodListValues.GetIsUserRegistered()){
                       var data = { pref: 'itemsPerPage', value: pageSize };
	                $.ajax({
	                    url: "/productlist/saveproductlistpref",
	                    type: "POST",
	                    data: JSON.stringify(data),
	                    contentType: 'application/json',
	                    dataType: 'json',
	                    success: function (result) {
	
	                    }
	                });
	             //}
                }
            };
            
            $scope.AddToTagList = function (term, elemId){
            		$scope.tagList.push({ v: term.toLowerCase(), id: elemId });
            		var elem = document.getElementById(elemId);
            		//alert(elem);
            };
            
            function toggleListIconColors() {
                for (var i in $scope.layoutTypes) {
                    var id = '#' + $scope.layoutTypes[i].id;
                    var selected = $(id);
                    if ($scope.layoutTypes[i].v === $scope.layoutType.v) {
                        selected.removeClass('textDkGray');
                        selected.addClass('textBlue');
                    } else {
                        selected.removeClass('textBlue');
                        selected.addClass('textDkGray');
                    }
                }
            }
            
            $scope.resize = function (columns, init) {
                $('#masterView').fadeTo(1, 0);
                //$('#masterLoading').show();
                getClass(columns);
                //$('#masterLoading').hide();
                $('#masterView').fadeTo(1, 1);
                toggleListIconColors();
 			
                if(!init){
                       var layout = 0;
                       if(columns == 1){
                       	layout = 2;
                       }
                       if(columns == 3){
                       	layout = 1;
                       }
                	   var data = { pref: 'layout', value: layout };
	                $.ajax({
	                    url: "/productlist/saveproductlistpref",
	                    type: "POST",
	                    data: JSON.stringify(data),
	                    contentType: 'application/json',
	                    dataType: 'json',
	                    success: function (result) {
	
	                    }
	                });
                }
            };
		$scope.resizeKeyPress = function(e, columns){
			if(e.which == 13){
				$scope.resize(columns);	
			}
		}
            $scope.items = [];
            $scope.favBoards = [];
             $scope.isUserRegistered = prodListValues.isUserRegistered;
             
            $scope.init = function (count, baseUrl, queryString) {
                $scope.itemCount = count;
                $scope.baseUrl = baseUrl;
                if (queryString.trim().length > 0) {
                    $scope.queryString = '?'+queryString;
                } else {
                    $scope.queryString = '';
                }
                
                //$('#masterLoading').hide();
                loadData();
                // set up layout         
                $scope.resize($scope.layoutType.v, true);
            };
            $scope.$on('$viewContentLoaded', function(event) {
                //Here your view content is fully loaded !!
                toggleListIconColors();
            });

            function getClass(columns) {
                if (columns === 5) {
                    $scope.layoutType = $scope.layoutTypes[0]; 
                    $scope.class = "c-md-2";
                    $scope.imageSize = 'thumb';
                    //$log.info("do 5 column stuff here");
                    //$(".toggleGrid").hide();
                    //$(".toggleSmall").show();
                     $('.peekHoverHide').each( function(){
                    		$(this).removeClass('peekHoverHide');
                    });
                    $scope.listClass = 'smallLayout';
                }
                else if (columns === 3) {
                    $scope.layoutType = $scope.layoutTypes[1];
                    $scope.class = "c-md-3";
                    $scope.imageSize = 'detail';
                    //$log.info("do 3 column stuff here");
                    //$(".toggleSmall").hide();
                    //$(".toggleGrid").show();
                    $('.peekHover').each( function(){
                    		$(this).addClass('peekHoverHide');
                    });
                    $scope.listClass = 'mediumLayout';
                }
                else if (columns === 1) {
                    $scope.layoutType = $scope.layoutTypes[2];
                    $scope.class = "c-md-13";
                    $scope.imageSize = 'detail';
                    $scope.listClass = 'listLayout';
                    //$log.info("do 1 column stuff here");
                    //$(".toggleSmall").hide();
                    //$(".toggleGrid").show();
                    $('.peekHover').each( function(){
                    		$(this).addClass('peekHoverHide');
                    });
                }
            }
            function GetSpecialLink(data){
            		if (data.IsCloseout && $scope.baseUrl != localizedJS.CloseoutLink.base) { return localizedJS.CloseoutLink;}
            		if (data.IsOnSale && $scope.baseUrl != localizedJS.SaleLink.base) { return localizedJS.SaleLink; }
            		if (data.IsPriceDrop && $scope.baseUrl != localizedJS.PriceDropLink.base && $scope.baseUrl != localizedJS.SaleLink.base) { return localizedJS.PriceDropLink; }
            		if (data.Is4iExclusive && $scope.baseUrl != localizedJS.ExclusiveLink.base) { return localizedJS.ExclusiveLink; }
            		return '';
            }

            function GetOnLoadData(num) {
                var pages = Math.floor(num);
                var loaded = 0;
                var items = [];
                var relevance = 0;
                var ind = window.location.href.indexOf('/search/');
                var term = '';
				if(ind > 0){
				term = window.location.href.substr(ind + 8).split('?')[0].split('/')[0];
				}
			
                function onDataLoad(data) {
                    loaded += 1;
                    for (var i = 0; i < data.length; i++) {
                        data[i].RoundedAverageRating = Math.round(data[i].AverageRating);
                        data[i].SpecialLink = GetSpecialLink(data[i]);
                        relevance += data[i].RelevenceScore;
                    }
                    items = items.concat(data);
                    if (loaded >= pages /* or timeout? */) {
                    	    if(relevance < 1 && term != ''){
                    	    	for (var i = 0; i < items.length; i++) {
                    	    		var rs = 0;
                    	    		if(items[i].ProductName.indexOf(term) >= 0){
                    	    			rs = 10;
                    	    		}
                    	    		if(items[i].TaglineText.indexOf(term) >= 0){
                    	    			rs += 2;
                    	    		}
                    	    		if(items[i].AverageRating > 1){
                    	    			rs += items[i].AverageRating;
                    	    		}
                    	    		if(items[i].IsOnSale){
                    	    			rs += 1;
                    	    		}
                    	    		if(items[i].ItemTagIDs){
                    	    			rs = rs + (items[i].ItemTagIDs.length/120);
                    	    		}else{
                    	    			rs = rs/3;
                    	    		}
                    	    		items[i].RelevenceScore = rs;
                    	    	}
                    	    }
                        $('#loadingItems').addClass('hide').hide();
                        $scope.items = items;
                        $('#defaultProductsFound').addClass('hide').hide();
                        $('#loadedProductsFound').removeClass('hide').show();
                    }
                    
                }
                return {
                    OnDataLoad: onDataLoad
                }
            }
		    function GetGetOnLoadDataRetry(){
		       var alreadyCalled = false;
			function getOnLoadDataRetry(num) {
			   if(!alreadyCalled){
				   alreadyCalled = true;
		                var pages = Math.floor(num);
		                var loaded = 0;
		                var items = [];
		                var relevance = 0;
		                var ind = window.location.href.indexOf('/search/');
		                var term = '';
						if(ind > 0){
							term = window.location.href.substr(ind + 8).split('?')[0].split('/')[0];
						}
					
		                function onDataLoad(data) {
		                    
		                    loaded += 1;
		                    for (var i = 0; i < data.length; i++) {
		                        data[i].RoundedAverageRating = Math.round(data[i].AverageRating);
		                        data[i].SpecialLink = GetSpecialLink(data[i]);
		                        if(typeof data[i].PercentageOff == "undefined"){
		                        	var patt = /\d\d%/;
		                        	var percent = data[i].SaleLegend.match(patt);
		                        	if(percent != null){
		                        		var dataitem = data[i];
		                        		dataitem["PercentageOff"] = + percent[0].substring(0,2);
		                        		//data[i]["PercentageOff"] = percent[0].substr(0,2);
		                        	}else{
		                        		dataitem["PercentageOff"] = 0;
		                        	}
		                        }
		                        relevance += data[i].RelevenceScore;
		                    }
		                    items = items.concat(data);
		                    if (loaded >= pages /* or timeout? */) {
		                    	    if(relevance < 1 && term != ''){
		                    	    	for (var i = 0; i < items.length; i++) {
		                    	    		var rs = 0;
		                    	    		if(items[i].ProductName.indexOf(term) >= 0){
		                    	    			rs = 10;
		                    	    		}
		                    	    		if(items[i].TaglineText.indexOf(term) >= 0){
		                    	    			rs += 2;
		                    	    		}
		                    	    		if(items[i].AverageRating > 1){
		                    	    			rs += items[i].AverageRating;
		                    	    		}
		                    	    		if(items[i].IsOnSale){
		                    	    			rs += 1;
		                    	    		}
		                    	    		if(items[i].ItemTagIDs){
		                    	    			rs = rs + (items[i].ItemTagIDs.length/120);
		                    	    		}else{
		                    	    			rs = rs/3;
		                    	    		}
		                    	    		items[i].RelevenceScore = rs;
		                    	    	}
		                    	    }
		                        $('#loadingItems').addClass('hide').hide();
		                        //document.getElementById('masterView').style.removeProperty("min-height");
		                        $scope.items = items;
		                        $('#defaultProductsFound').addClass('hide').hide();
		                        $('#loadedProductsFound').removeClass('hide').show();
		                    }
	                    }
	                }
	                return {
	                    OnDataLoad: onDataLoad
	                }
	            }
	            return{
	            	GetOnLoadDataRetry: getOnLoadDataRetry
	            }
            }

            function loadData() {
                var itemsPerPage = 400;
		   var itemsPerPageRetry = 200;
                var tempItems = [];
                var pages = (($scope.itemCount % itemsPerPage) > 0) ? ($scope.itemCount / itemsPerPage) + 1 : ($scope.itemCount / itemsPerPage);
				var pagesRetry = (($scope.itemCount % itemsPerPageRetry) > 0) ? ($scope.itemCount / itemsPerPageRetry) + 1 : ($scope.itemCount / itemsPerPageRetry);

                if (pages > 2) {
                    $('#loadingItems').removeClass('hide').show();
                }

                var onLoad = GetOnLoadData(pages);
                var getOnLoadRetry = GetGetOnLoadDataRetry();
                if ($scope.items.length < $scope.itemCount) {
                    for (var i = 1; i <= pages; i++) {

                        dataFactory.getData($scope.baseUrl + '/' + i + '/' + itemsPerPage + $scope.queryString).then(
	                        function (response) {
	                                onLoad.OnDataLoad(response.data);
	                        },
	                        function (error) {
	                            $scope.status = 'Unable to load product data: ' + error;
					var onLoadRetry = getOnLoadRetry.GetOnLoadDataRetry(pagesRetry);
					for (var i = 1; i <= pagesRetry; i++) {
						dataFactory.getData($scope.baseUrl + '/' + i + '/' + itemsPerPageRetry + $scope.queryString).then(
							function (response) {
								onLoadRetry.OnDataLoad(response.data);
							},
							function (error) {
								$scope.status = 'Unable to load product data: ' + error;
							}
						);
					}
	                        }
	                        
                        );
                    }
                }

            };
        }]);

    /***Filters**/

    pagination.filter('filterPrice', function () {
        return function (items) {
            var minx = document.getElementById('PriceMin').value;
            var maxx = document.getElementById('PriceMax').value;
            if (minx == '' && maxx == '') {
                return items;
            }
            var filtered = [];
            var min = minx;
            var max = maxx;
            // If price is with the range
            angular.forEach(items, function (item) {
                if (item.LowestSellPriceAmount >= min && item.LowestSellPriceAmount <= max) {
                    filtered.push(item);
                }
            });
            return filtered;
        };
    });
    pagination.filter('filterColor', function () {
        return function (items, colorMapIDs) {
            if (colorMapIDs == null || colorMapIDs == '') {
                return items;
            }
            var mapIDs = colorMapIDs.split(' ');

            var filtered = [];
            angular.forEach(items, function (item) {
                var i;
                var j;

                outermost: for (i = 0; i < item.ColorGroups.length; i++) {
                    for (j = 0; j < mapIDs.length; j++) {
                        if (item.ColorGroups[i].ColorMappingID == mapIDs[j]) {
                            if (mapIDs.length == 1 && item.IsRecolorable) {
                                item.ColorImageThumbNailTemp = item.ThumbNailImage.substring(0, item.ThumbNailImage.lastIndexOf('/') - 3) + 'rend/150/' + item.ProductID + '/' + item.ColorGroups[i].BaseColorID + '_' + item.ColorGroups[i].TrimColorID + '.jpg';
                                item.ColorImageDetailTemp = item.ColorImageThumbNailTemp.replace('rend/150/', 'rend/250/');
                            } else {
                                item.ColorImageThumbNailTemp = item.ThumbNailImage;
                                item.ColorImageDetailTemp = item.DetailImage;
                            }
                            filtered.push(item);
                            break outermost;
                        }
                    }
                }

            });

            return filtered;
        };
    });
    pagination.filter('filterTags', function () {
        return function (items, tags) {
            if (tags == null || tags == '') {
                return items;
            }


            var tagCountStrings = tags.split('^');
            var tagGroups = [];
            var found = true;
            var countGroup = '';
            var countTag = '';
            var tagGroupStrings = tagCountStrings[0].split('#');
            if (tagCountStrings.length == 2) {
                var tagCountStringVals = tagCountStrings[1].split('_');
                countGroup = tagCountStringVals[0];
                countTag = tagCountStringVals[1];
                found = false;
            }
            var h;
            for (h = 0; h < tagGroupStrings.length; h++) {
                var vals = tagGroupStrings[h].split('_');
                var group = vals[0];
                var tags = [];
                if (!found && countGroup == group) {
                    if (vals.length > 1) {
                        tags = vals[1].split('-');
                    }
                    tags.push(countTag);
                    tagGroups.push(
                            {
                                'group': group,
                                'tags': tags
                            }
                    );
                    found = true;
                }
                else {
                    if (vals.length > 1) {
                        tags = vals[1].split('-');
                        if (tags.length > 0) {
                            tagGroups.push(
                                 {
                                     'group': group,
                                     'tags': tags
                                 }
                            );
                        }
                    }
                }
            }
            if (!found) {
                var t = [];
                t.push(countTag);
                tagGroups.push(
                    {
                        'group': countGroup,
                        'tags': t
                    }
                );
            }
            var filtered = [];
            angular.forEach(items, function (item) {
                var i;
                var j;
                var k;
                var keep = true;
                outermost: for (i = 0; i < tagGroups.length; i++) {
                    for (j = 0; j < item.ItemTagIDs.length; j++) {
                        for (k = 0; k < tagGroups[i].tags.length; k++) {
                            if (
                                (tagGroups[i].group == 'HelpfulLinks' &&
                                    (
                                        (tagGroups[i].tags[k] == localizedJS.SaleTagID && item.IsOnSale) ||
                                        (tagGroups[i].tags[k] == localizedJS.HottestTagID && item.IsHot) ||
                                        (tagGroups[i].tags[k] == localizedJS.NewTagID && item.IsNew)
                                    )
                                ) || item.ItemTagIDs[j] == tagGroups[i].tags[k]
                               ) {
                                continue outermost;
                            }
                        }
                    }
                    keep = false;
                    break;
                }
                if (keep) { //if item had atleast 
                    filtered.push(item);
                }
            });

            return filtered;
        };
    });
    pagination.filter('filterRating', function () {
        return function (items, ratings) {
            if (ratings == null || ratings == '') {
                return items;
            }
            var ratingList = ratings.split(' ');
            var filtered = [];
            angular.forEach(items, function (item) {
                for (var i = 0; i < ratingList.length; i++) {
                    if (item.RoundedAverageRating == ratingList[i]) {
                        filtered.push(item);
                    }
                }
            });
            return filtered;
        };
    });
    pagination.filter('filterProductionTime', function () {
        return function (items, filterdata) {
            if (filterdata == null || filterdata == '') {
                return items;
            }
            var filtered = [];
            var prodTime = filterdata;
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                if (item.ProductionTime <= prodTime) {
                    filtered.push(item);
                }
            }
            return filtered;
        };
    });
   pagination.filter('filterImprintLocationCount', function () {
        return function (items, filterdata) {
            if (filterdata == null || filterdata == '') {
                return items;
            }
            var filtered = [];
            var impLoc = filterdata;
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                if (item.ImprintLocationCount <= 1 && impLoc == 0 && !item.Product_Imprints_Available) {
                	filtered.push(item);
                }
                if (item.ImprintLocationCount == impLoc && impLoc == 1 && item.Product_Imprints_Available) {
                    filtered.push(item);
                }
                if (item.ImprintLocationCount >= impLoc && impLoc != 1 && impLoc != 0) {
                    filtered.push(item);
                }
            }
            return filtered;
        };
    });
    pagination.filter('filterImprintColorCount', function () {
        return function (items, filterdata) {
            if (filterdata == null || filterdata == '') {
                return items;
            }
            var filtered = [];
            var impColorCount= filterdata;
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                if (item.MaxImprintColors == impColorCount && impColorCount == 0 && !item.Product_Imprints_Available) {
                    filtered.push(item);
                }
                if ((item.MaxImprintColors == impColorCount && impColorCount == 1) || 
                (item.Product_Imprints_Available && item.MaxImprintColors == 0 && impColorCount == 1)) {
                    filtered.push(item);
                }
                if (item.MaxImprintColors >= impColorCount && impColorCount != 1 && impColorCount != 0) {
                    filtered.push(item);
                }                
            }
            return filtered;
        };
    });
       pagination.filter('filterSearch', function () {
        return function (items, filterdata) {
            if (filterdata == null || filterdata == '') {
                return items;
            }
            var filtered = [];
            var searchWords = filterdata.toLowerCase().split(' ');
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var keep = true;
                for(var j = 0; j < searchWords.length; j++){
                	   var searchWord = " " + searchWords[j];
                	   var catSearch = searchWords[j].split('-')[0];
	                if (!(item.ProductName.toLowerCase().indexOf(searchWords[j]) + 1) && ! (item.ProductDescription.indexOf(searchWord)+1) && !(item.CatalogAlias.toLowerCase().split('-')[0] === catSearch ) ) {
	                    keep = false;
	                    break;
	                }
                }
                if(keep){
                	filtered.push(item);
                }
            }
            return filtered;
        };
    });
    pagination.filter('renderHtml', ['$sce',
        function ($sce) {
            return function (html) {
                return $sce.trustAsHtml(html);
            };
        }
    ]);
    /*
pagination.filter('reverse', function () {
    return function (items) {
        return items.slice().reverse();
    };
});
*/

	pagination.filter('htmlEncode', function () {
        return function (x) {
            return x
            	.replace(/&/g, '&amp;')
        	.replace(/"/g, '&quot;')
        	.replace(/'/g, '&#39;')
        	.replace(/</g, '&lt;')
        	.replace(/>/g, '&gt;');
        };
    });
    
    pagination.filter('jsonldRatings', function () {
        return function (ratingVal, ratingCount) {
            if (ratingVal >= 1)
            {
            		return "\"aggregateRating\": { \"@type\": \"AggregateRating\", \"bestRating\": \"5\", \"worstRating\": \"1\", \"ratingValue\": \"" + ratingVal + "\",\"reviewCount\": \"" + ratingCount+ "\" },";
            }else{
            	return '';
            }
        };
    });


    /***Directives***/

    // from Christian Grobmeier
    // https://www.grobmeier.de/angular-js-the-show-on-mouseenter-hide-on-mouseleave-directive-31082012.html
    pagination.directive('showonhoverparent',
       function () {
           return {
               link: function (scope, element, attrs) {
                   element.parent().on('mouseenter', function () {
                   if (!element.hasClass('peekHoverHide')) {
                           element.show();
                       }
                   });
                   element.parent().on('mouseleave', function () {
                       element.hide();
                   });
                   
                   element.siblings().on('keypress', function(e){
                   	if(e.which == 13){
                   		var lnk = element.find('a');
                   		element.show();
                   		lnk.focus();
                   		lnk.on("blur", function(){ element.hide();});
                   	}
                   	});
               }
           };
       });

	var listVideos = new videos4i();
	pagination.directive('playVideo', function() {
		return { 
			link:  function link(scope, element) {
				element.bind("click", function(){
					listVideos.initDynamicLink(this);
				});
	    		}
	  	}
	});


  function htmlEscape(str) {
    return str
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
	}
    
    	function fixedEncodeURIComponent(str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
			return '%' + c.charCodeAt(0).toString(16);
		});
	}

    function UpdatedSearchUrl(resetPage) {
        var currentUrl = window.location.href;
        var baseUrl = '';
        var newQueryString = '';
        var matches = prodListValues.SubSearchPattern.exec(currentUrl);
        var searchTerm = $('#txtInnerSearch').val();
        if (searchTerm.trim().length > 0) {
            newQueryString = '?ss=' + fixedEncodeURIComponent(searchTerm.trim());
        } else {
            $('#searchValue').val('');
        }
        matches = prodListValues.SortByPattern.exec(currentUrl);
        if (matches != null) {
            if (newQueryString == '') {
                newQueryString = '?' + matches[0];
            } else {
                newQueryString = newQueryString + '&' + matches[0];
            }
        }
        matches = prodListValues.ItemsPerPagePattern.exec(currentUrl);
        if (matches != null) {
            if (newQueryString == '') {
                newQueryString = '?' + matches[0];
            } else {
                newQueryString = newQueryString + '&' + matches[0];
            }
        }
        if ($('#aSearchQueryUrl').val().trim().length > 0) {
            if (newQueryString == '') {
                newQueryString = '?' + $('#aSearchQueryUrl').val();
            } else {
                newQueryString = newQueryString + '&' + $('#aSearchQueryUrl').val();
            }
        }
        if (!resetPage) {
            matches = prodListValues.PagePattern.exec(currentUrl);
            if (matches != null) {
                if (newQueryString == '') {
                    newQueryString = '?' + matches[0];
                } else {
                    newQueryString = newQueryString + '&' + matches[0];
                }
            }
        }
        var urlArray = currentUrl.split('/');
        var prot = urlArray[0];
        var host = urlArray[2];
        var url = prot + '//' + host;
        baseUrl = newQueryString;
        if (baseUrl == '') {
            baseUrl = currentUrl;
            if (baseUrl.indexOf('?') > -1) {
                baseUrl = baseUrl.slice(0, baseUrl.indexOf('?'));
            }
        }
        prodListValues.ReplaceCurrentUrl(baseUrl.replace(url, ''), productListMeta.GetTitle(), productListMeta.GetDescription(), productListMeta.GetKeywords());
    }

    function UpdateSortByUrl(resetPage) {
        var currentUrl = window.location.href;
        var baseUrl = '';
        var options = $('#sortBy>option:selected');
        var option = options[0].value;
        var sortByString = '';
        var newQueryString = '';
        var i = 0;
        
        for (i = 0; i < prodListValues.SortMap.length; i++) {
            if (prodListValues.SortMap[i].v.toLowerCase() == option.toLowerCase()) {
                sortByString = prodListValues.SortMap[i].q;
                break;
            }
        }
        var matches = prodListValues.SubSearchPattern.exec(currentUrl);
        if (matches != null) {
            newQueryString = '?' + matches[0];
        }
        if (sortByString != '') {
            if (newQueryString == '') {
                newQueryString = '?' + sortByString;
            } else {
                newQueryString = newQueryString + '&' + sortByString;
            }
        }
        matches = prodListValues.ItemsPerPagePattern.exec(currentUrl);
        if (matches != null) {
            if (newQueryString == '') {
                newQueryString = '?' + matches[0];
            } else {
                newQueryString = newQueryString + '&' + matches[0];
            }
        }
        if ($('#aSearchQueryUrl').val().trim().length > 0) {
            if (newQueryString == '') {
                newQueryString = '?' + $('#aSearchQueryUrl').val();
            } else {
                newQueryString = newQueryString + '&' + $('#aSearchQueryUrl').val();
            }
        }
        if (!resetPage) {
            matches = prodListValues.PagePattern.exec(currentUrl);
            if (matches != null) {
                if (newQueryString == '') {
                    newQueryString = '?' + matches[0];
                } else {
                    newQueryString = newQueryString + '&' + matches[0];
                }
            }
        }
        baseUrl = baseUrl + newQueryString;
        var urlArray = currentUrl.split('/');
        var prot = urlArray[0];
        var host = urlArray[2];
        var url = prot + '//' + host;
        prodListValues.ReplaceCurrentUrl(baseUrl.replace(url, ''), productListMeta.GetTitle(), productListMeta.GetDescription(), productListMeta.GetKeywords());
    }

    function UpdateItemsPerPageUrl(resetPage) {
        var currentUrl = window.location.href;
        var baseUrl = '';
        var options = $('#showOnPage>option:selected');
        var vals = options[0].value.split(':');
        var itemsPerPage = vals[1];
        var newQueryString = '';
        var matches = prodListValues.SubSearchPattern.exec(currentUrl);
        if (matches != null) {
            newQueryString = '?' + matches[0];
        }
        matches = prodListValues.SortByPattern.exec(currentUrl);
        if (matches != null) {
            if (newQueryString == '') {
                newQueryString = '?' + matches[0];
            } else {
                newQueryString = newQueryString + '&' + matches[0];
            }
        }
        if (newQueryString == '') {
            newQueryString = '?PS=' + itemsPerPage;
        } else {
            newQueryString = newQueryString + '&PS=' +itemsPerPage;
        }
        if ($('#aSearchQueryUrl').val().trim().length > 0) {
            if (newQueryString == '') {
                newQueryString = '?' + $('#aSearchQueryUrl').val();
            } else {
                newQueryString = newQueryString + '&' + $('#aSearchQueryUrl').val();
            }
        }
        if (!resetPage) {
            matches = prodListValues.PagePattern.exec(currentUrl);
            if (matches != null) {
                if (newQueryString == '') {
                    newQueryString = '?' + matches[0];
                } else {
                    newQueryString = newQueryString + '&' + matches[0];
                }
            }
        }
        baseUrl = baseUrl + newQueryString;
        var urlArray = currentUrl.split('/');
        prot = urlArray[0];
        host = urlArray[2];
        var url = prot + '//' + host
        prodListValues.ReplaceCurrentUrl(baseUrl.replace(url, ''), productListMeta.GetTitle(), productListMeta.GetDescription(), productListMeta.GetKeywords());
    }

        function addSelectedSubSearch(search){
          var list = $('#selectedFilterList');
          var newDiv =  '<div id = "selectedSubSearch" class="clear selectedFilter selectedSubSearch"><label class="text14 c-xs-quarter-3 inlineMiddle noPadding">' + localizedJS.SelectedSubSearchFormat.replace('##search##', search) + '</label><div class="inlineMiddle c-xs-quarter-1 noPadding"><a class="noLine floatRight darkLink padding5 pointer" OnClick="removeSubSearchFilter()" onkeypress="keyPressRemoveSSFilter(event)" tabindex="0" title="Remove subsearch filter"><svg class="show" height="20px" width="20px" aria-label="remove this filter"><label>Remove this filter</label><use xlink:href="#svgIcon-remove"></use></svg></a></div></div>';
          list.append(newDiv);
          var sF = $('.selectedFilters');
          if (sF.hasClass("hide")) {
              sF.removeClass("hide").show();
          }
    }